import { useRouter } from "../router";
import { InvestorList } from "./crm/InvestorList";
import { InvestorView } from "./crm/InvestorView";
import { InvestorForm } from "./crm/InvestorForm";
import { Placeholder } from "../components/Placeholder";

export function Crm() {
  const { pathname } = useRouter();
  const sub = pathname.split("/").filter(Boolean).slice(2);

  if (sub.length === 0) return <InvestorList />;
  if (sub[0] === "new") return <InvestorForm mode="create" />;

  const id = Number(sub[0]);
  if (!Number.isInteger(id) || id <= 0) return <NotFound />;

  if (sub.length === 1) return <InvestorView id={id} tab="profile" />;
  if (sub.length === 2) {
    if (sub[1] === "edit") return <InvestorForm mode="edit" id={id} />;
    if (sub[1] === "members") return <InvestorView id={id} tab="members" />;
    if (sub[1] === "portfolio") return <InvestorView id={id} tab="portfolio" />;
    if (sub[1] === "orders") return <InvestorView id={id} tab="orders" />;
    if (sub[1] === "quantfolio") return <InvestorView id={id} tab="quantfolio" />;
    if (sub[1] === "documents") return <InvestorView id={id} tab="documents" />;
    if (sub[1] === "activity") return <InvestorView id={id} tab="activity" />;
  }

  return <NotFound />;
}

function NotFound() {
  return (
    <Placeholder
      eyebrow="CRM"
      title="Page not found."
      lede="That investor or sub-page doesn't exist."
      milestone="Go back to investors"
    />
  );
}
